export default function PanelWaiting(props: { message?: string }) {
  return (
    <div className="fullscreen">
      <div className="waiting">
        <img src="/static/img/waiting.gif" />
        {props.message ?? ""}...
      </div>
    </div>
  );
}
